import React from "react";
import styled from "styled-components";
import { Data } from "../Data";
import {
  BsTelephone,
  BsInstagram,
  BsFacebook,
  BsMailbox,
  BsPinterest,
  BsPinMap,
} from "react-icons/bs";
const Contact = () => {
  const size = 70;
  const data = Data;
  return (
    <StyledContact id="contact">
      <h1>{data.contactTitle}</h1>

      <div className="column">
        {data.phone === "x" || data.phone === "X" ? (
          ""
        ) : (
          <a
            href="#"
            className="row"
          >
            <BsTelephone size={size} />
            <p>{data.phone}</p>
          </a>
        )}
        {data.email === "x" || data.email === "X" ? (
          ""
        ) : (
          <a
            href="#"
            className="row"
          >
            <BsMailbox size={size} />
            <p>{data.email}</p>
          </a>
        )}
        {data.instagram === "x" || data.instagram === "X" ? (
          ""
        ) : (
          <a
            href="#"
            className="row"
          >
            <BsInstagram size={size} />
            <p>{data.instagram}</p>
          </a>
        )}
        {data.facebook === "x" || data.facebook === "X" ? (
          ""
        ) : (
          <a
            href="#"
            className="row"
          >
            <BsFacebook size={size} />
            <p>{data.facebook}</p>
          </a>
        )}
        {data.pinterest === "x" || data.pinterest === "X" ? (
          ""
        ) : (
          <a
            href="#"
            className="row"
          >
            <BsPinterest size={size} />
            <p>{data.pinterest}</p>
          </a>
        )}
        {data.address === "x" || data.address === "X" ? (
          ""
        ) : (
          <a
            href="#"
            className="row"
          >
            <BsPinMap size={size} />
            <p>{data.address}</p>
          </a>
        )}
      </div>
    </StyledContact>
  );
};

export default Contact;

const StyledContact = styled.section`
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: 992px) {
    height: fit-content;
    padding-bottom: 20vh;
  }
  h1 {
    padding-top: 15vh;
  }

  .row {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 2rem;
  }
  .column {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: var(--medium) 4rem;
    @media (max-width: 992px) {
      grid-template-columns: 1fr;
      grid-gap: 4rem 0;
    }
    a {
      font-size: var(--medium);
      @media (max-width: 992px) {
        display: flex;
        flex-direction: column;
      }
    }
  }
`;
